import { render, staticRenderFns } from "./RecentActivityList.vue?vue&type=template&id=9a0de1d0"
import script from "./RecentActivityList.vue?vue&type=script&lang=js"
export * from "./RecentActivityList.vue?vue&type=script&lang=js"
import style0 from "./RecentActivityList.vue?vue&type=style&index=0&id=9a0de1d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports